
$(window).bind("load", function() {
  var arrMainProductIdwiseQuantity = [];
  var objPersonalizedProductDetail = {};
  var allCartObject = [];
  $.ajax({
    async: false,
    url: "/cart.js",
    success: function( response ) {
      var lineItemDetail = response.items;
      lineItemDetail.forEach((item) => {
        if(typeof(item.properties['_Related Product Id']) == "undefined"){
          arrMainProductIdwiseQuantity[item.id] = item.quantity;
        }
        else{
          var productData = [];            
          productData['id'] = item.key;
          productData['relatedProduct'] = item.properties['_Related Product Id'];
          productData['quantity'] = item.quantity;
          objPersonalizedProductDetail[item.properties['_Related Product Id']] = productData;
        }
      });
      
      var cartProperties = {};
      Object.keys(objPersonalizedProductDetail).forEach(key => {
        cartProperties = {};
        if(objPersonalizedProductDetail[key]['quantity'] != arrMainProductIdwiseQuantity[key]){
          cartProperties['id'] = objPersonalizedProductDetail[key]['id'];
          if(arrMainProductIdwiseQuantity.hasOwnProperty(key)){
            cartProperties['quantity'] = arrMainProductIdwiseQuantity[key];
          }
          else{
            cartProperties['quantity'] = 0;
          }
          cartProperties['sections'] = ["mini-cart"];
          allCartObject.push(cartProperties);
        }
      });
      allCartObject.forEach((cartDetail) => {
        updateFunction(cartDetail);
      });  
      setTimeout(function(){
        if(allCartObject.length > 0){
          window.location.reload();
        }
      }, 2000 );
    },
    dataType: "json"
  });
      
});

async function updateFunction(cartDetail){
  let updatedResponse = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
    body: JSON.stringify(cartDetail),
    credentials: "same-origin",
    method: "POST",
    headers: {
    "Content-Type": "application/json"
    }
  });
}